// extracted by mini-css-extract-plugin
export default {"wrapper":"carrier-review-module__wrapper--iIN","tooltip-paragraph":"carrier-review-module__tooltip-paragraph--Giv","tooltipParagraph":"carrier-review-module__tooltip-paragraph--Giv"};